import { Text, TextProps } from '@chakra-ui/react';
import { ReactNode } from 'react';

interface TermTextProps extends TextProps {
  children: ReactNode;
  noMargin?: boolean;
}

export const TermsText = ({ children, noMargin = false, ...rest }: TermTextProps) => (
  <Text
    fontSize="18px"
    fontWeight={400}
    lineHeight="28px"
    letterSpacing="0"
    color="#4A5769"
    fontFamily="primary"
    mb={noMargin ? 0 : '16px'}
    {...rest}
  >
    {children}
  </Text>
);
